import { Badge } from "primeng/badge";

export const SIDE_MENU_CONSTANTS: any = {
    MENU_ITEMS: [
        {
            label: 'Home',
            icon: 'home',
            link: 'landing',
            resourceName : 'Kavach',
            resourceTypeName: 'Application',
        },
        //  {
        //     label: 'Zone Rules',
        //     icon: 'book-2',
        //     link: 'zone-rules',
        //     resourceName : 'Kavach',
        //     resourceTypeName: 'Application',
        // },
        {
            label: 'Organizations',
            icon: 'building',
            link: 'usermgmt/customer',
            resourceName : 'User Management',
            resourceTypeName: 'Application',
        },
        {
            label: 'Applications',
            icon: 'layout-2',
            link: 'usermgmt/applications',
             resourceName : 'User Management',
            resourceTypeName: 'Application',
        },
        {
            label: 'Roles',
            icon: 'key',
            link: 'usermgmt/roles',
             resourceName : 'User Management',
            resourceTypeName: 'Application',
        },
        {
            label: 'Users',
            icon: 'users',
            link: 'usermgmt/users',
             resourceName : 'User Management',
            resourceTypeName: 'Application',
        },
        
    ]
}